import { t, tf } from "./i18n.js";
import { erzeugeAufnahmeEingabe } from "./aufnahme-eingabe.js";
// ==========================================
// BOB'S 27 LOGIK
// ==========================================
window.bobsPlayer = null;
let bobsTargetIndex = 1; // 1 bis 21 (21 = Bull)
let bobsHistoryStack = [];
let isBobsGameOver = false;
let isBobsEasyMode = false;

const bobsTargets = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25,
];

function startBobsGame() {
  const nameInput =
    document.getElementById("bobs-player-input").value.trim() || t("js.app.009");

  bobsPlayer = {
    name: nameInput,
    score: 27,
    pointsTable: [],
  };
  bobsTargetIndex = 1;
  bobsHistoryStack = [];
  isBobsGameOver = false;

  isBobsEasyMode = document.getElementById("chk-bobs-easy")?.checked || false;

  document.getElementById("btn-undo-bobs").style.display = "none";
  document.getElementById("bobs-setup-screen").style.display = "none";
  document.getElementById("game-bobs-screen").style.display = "block";

  // ERST sichtbar machen, DANN die Eingabe bauen: Der Container existiert
  // zwar immer, aber createDartboard misst beim Zeichnen - in einem
  // display:none-Teilbaum kaeme ein Board ohne Groesse heraus.
  bobsEingabe.baue();
  bobsEingabe.leere();
  bobsEingabe.aktualisiereSichtbarkeit();

  updateBobsUI();

  // Spielwache scharf (29.08.2026).
  spielwacheSpielGestartet("bobs", sichereBobsStand);
}

// ── Spielwache: sichern & wiederherstellen (29.08.2026) ─────────────────
function sichereBobsStand() {
  return {
    player: bobsPlayer,
    targetIndex: bobsTargetIndex,
    easy: isBobsEasyMode,
  };
}

function stelleBobsWieder(stand) {
  openBobsSetup();
  bobsPlayer = { ...stand.player };
  bobsTargetIndex = stand.targetIndex;
  isBobsEasyMode = !!stand.easy;
  bobsHistoryStack = [];
  isBobsGameOver = false;

  const nameFeld = document.getElementById("bobs-player-input");
  if (nameFeld) nameFeld.value = bobsPlayer.name;
  const leichtHaken = document.getElementById("chk-bobs-easy");
  if (leichtHaken) leichtHaken.checked = isBobsEasyMode;
  const undoBtn = document.getElementById("btn-undo-bobs");
  if (undoBtn) undoBtn.style.display = "none";

  document.getElementById("bobs-setup-screen").style.display = "none";
  document.getElementById("game-bobs-screen").style.display = "block";
  bobsEingabe.baue();
  bobsEingabe.leere();
  bobsEingabe.aktualisiereSichtbarkeit();
  updateBobsUI();
  spielwacheSpielGestartet("bobs", sichereBobsStand);
}

spielwacheRegistriereFortsetzen("bobs", "Bob's 27", stelleBobsWieder);

function cancelBobsGame() {
  cancelCurrentGame("game-bobs-screen");
}

function updateBobsUI() {
  const targetVal = bobsTargets[bobsTargetIndex - 1];

  document.getElementById(
    "bobs-turn-indicator"
  ).innerHTML = tf("js.bobs.003", { p1: bobsPlayer.name });
  document.getElementById("bobs-current-score").innerText = bobsPlayer.score;

  let targetDisplay = targetVal === 25 ? "BULL" : `D${targetVal}`;
  document.getElementById("bobs-target-display").innerText = targetDisplay;

  // Zielfeld auf der echten Scheibe hervorheben (frueher: das stilisierte
  // Board aus ui.js neu zeichnen). Die Marken der laufenden Aufnahme bleiben
  // dabei stehen - zeigeZiel() ruehrt nur die Segmente an.
  bobsEingabe.aktualisiereZiel();
  bobsEingabe.zeichne();
  updateBobsHistoryUI();
  // Nach jeder Standaenderung spiegeln (spielwache.js, 29.08.2026).
  if (typeof spielwacheTick === "function") spielwacheTick();
}

function submitBobsScore(hits) {
  if (isBobsGameOver || !bobsPlayer) return;
  // Snapshot für Undo speichern (+ tableLength)
  bobsHistoryStack.push({
    score: bobsPlayer.score,
    targetIndex: bobsTargetIndex,
    tableLength: bobsPlayer.pointsTable.length, // <-- NEU
  });
  document.getElementById("btn-undo-bobs").style.display = "block";

  const targetVal = bobsTargets[bobsTargetIndex - 1];
  let pointsChange = 0;

  // Punkte berechnen
  if (hits > 0) {
    pointsChange = targetVal * 2 * hits;
    bobsPlayer.score += pointsChange;
  } else {
    pointsChange = -(targetVal * 2);
    bobsPlayer.score += pointsChange;
  }

  // <-- NEU: Wurf in die Historie speichern -->
  bobsPlayer.pointsTable.push({
    target: targetVal,
    hits: hits,
    points: pointsChange,
  });

  // Rausschmiss prüfen
  if (bobsPlayer.score < 0 && !isBobsEasyMode) {
    isBobsGameOver = true;
    saveBobsStatsBackground(false);
    spielwacheSpielBeendet();

    // Gemeinsamer Endbildschirm statt Toast + goHome (Produkttest
    // 29.08.2026) - auch der Rausschmiss verdient ein Ergebnis.
    setTimeout(() => {
      zeigeEndbildschirm({
        screenId: "game-bobs-screen",
        titel: t("js.ende.fertig"),
        untertitel: t("js.bobs.001"),
        zeilen: [],
        kennzahlen: [
          { label: t("js.ende.punkte"), wert: bobsPlayer.score },
          {
            label: t("aufnahme.ziel"),
            // Das Feld, an dem Schluss war - gleiche Schreibweise wie in
            // der Anzeige (D-Wert bzw. BULL).
            wert:
              bobsTargets[bobsTargetIndex - 1] === 25
                ? "BULL"
                : `D${bobsTargets[bobsTargetIndex - 1]}`,
          },
        ],
        revanche: () => startBobsGame(),
        setup: () => openBobsSetup(),
      });
    }, 300);
    return;
  }

  bobsTargetIndex++;

  if (bobsTargetIndex > 21) {
    isBobsGameOver = true;
    saveBobsStatsBackground(true);
    spielwacheSpielBeendet();

    // Gemeinsamer Endbildschirm statt Toast + goHome (Produkttest
    // 29.08.2026).
    zeigeEndbildschirm({
      screenId: "game-bobs-screen",
      titel: t("js.ende.geschafft"),
      untertitel: isBobsEasyMode ? t("js.bobs.005") : t("js.bobs.004"),
      zeilen: [],
      kennzahlen: [{ label: t("js.ende.punkte"), wert: bobsPlayer.score }],
      revanche: () => startBobsGame(),
      setup: () => openBobsSetup(),
    });
    return;
  }

  updateBobsUI();
}

function undoBobsTurn() {
  if (bobsHistoryStack.length === 0) return;
  const lastState = bobsHistoryStack.pop();

  bobsPlayer.score = lastState.score;
  bobsTargetIndex = lastState.targetIndex;
  // <-- NEU: Letzten Wurf aus der Historie entfernen
  bobsPlayer.pointsTable = bobsPlayer.pointsTable.slice(
    0,
    lastState.tableLength
  );

  if (bobsHistoryStack.length === 0)
    document.getElementById("btn-undo-bobs").style.display = "none";

  // Die Kacheln gehoeren zum zurueckgenommenen Zug. Blieben sie stehen,
  // wuerden sie beim naechsten "Next" ein zweites Mal gewertet.
  bobsEingabe.leere();
  updateBobsUI();
}

function updateBobsHistoryUI() {
  if (!bobsPlayer) return;
  renderUniversalMiniGameHistory(
    "side-history-list-bobs",
    "history-bobs-name",
    bobsPlayer.name,
    bobsPlayer.pointsTable,
    "bobs"
  );
}

// NEU: Supabase Speicherfunktion für Bob's 27 (läuft leise im Hintergrund)
async function saveBobsStatsBackground(isWin) {
  if (isBobsEasyMode) return;
  try {
    const payload = {
      name: bobsPlayer.name,
      final_score: bobsPlayer.score,
      is_win: isWin,
      details: bobsPlayer.pointsTable, // Speichert das Array als JSONB
    };

    // Wenn der User eingeloggt ist (aus app.js), verknüpfen wir die user_id
    if (typeof currentUser !== "undefined" && currentUser) {
      payload.user_id = currentUser.id;
    }

    const { error } = await _supabase.from("stats_bobs").insert([payload]);

    if (error) {
      console.error(t("js.bobs.002"), error.message);
    } else {
      console.log(
        "✅ Bob's 27 Stats erfolgreich im Hintergrund in Supabase gespeichert!"
      );
    }
  } catch (err) {
    console.error(t("js.g121.002"), err);
  }
}

// ---------------------------------------------------------------------------
// EINGABE (14.08.2026): drei Darts statt "wie oft getroffen?"
//
// Vorher nahm Bob's 27 nur eine Trefferzahl entgegen (0x/1x/2x/3x). Damit war
// der Modus fuer den Tracker nicht anschliessbar: Der liefert einzelne Darts,
// und wer sie vorher zu einer Zahl zusammenrechnet, wirft genau das weg, was
// die Statistik braucht - WO die Pfeile steckten.
//
// Jetzt sammelt der gemeinsame Baustein drei Darts (Board, Tastatur oder
// Tracker), und Bob's leitet seine Trefferzahl daraus ab. Die Wertung selbst
// bleibt unveraendert in submitBobsScore().
// ---------------------------------------------------------------------------

/** Zaehlt beim aktuellen Ziel als Treffer.
 *
 *  Der Massstab folgt exakt der Zielanzeige in updateBobsUI(): "D<n>" heisst
 *  Doppel des Ziels, "BULL" heisst 25 ODER 50 - das aeussere Bull ist bei
 *  Bob's das Doppel-Aequivalent, das Bullseye zaehlt selbstverstaendlich mit.
 *
 *  `mult` UND `multiplier` werden gelesen: Handdarts (board-input.js,
 *  aufnahme-eingabe.js) fuehren `multiplier`, der Tracker-Payload `mult`.
 *  Nur eines abzufragen hat frueher schon Treffer verschluckt. */
function bobsTrifft(dart) {
  if (!dart) return false;
  const ziel = bobsTargets[bobsTargetIndex - 1];
  const base = Number(dart.base ?? 0);
  const mult = Number(dart.multiplier ?? dart.mult ?? 1);
  if (ziel === 25) return base === 25 || base === 50;
  return base === ziel && mult === 2;
}

const bobsEingabe = erzeugeAufnahmeEingabe({
  modus: "bobs",
  ziel: () => document.getElementById("aufnahme-bobs"),
  aktiv: () =>
    document.getElementById("game-bobs-screen")?.style.display !== "none" &&
    !!bobsPlayer &&
    !isBobsGameOver,
  // Das Zielfeld auf der echten Scheibe. Beim Bull beide Ringe - genau die
  // Felder, die bobsTrifft() auch wirklich zaehlt. Blinkt etwas anderes als
  // gewertet wird, ist die Anzeige eine Falle.
  zielFelder: () => {
    const ziel = bobsTargets[bobsTargetIndex - 1];
    return ziel === 25
      ? [{ base: 25 }, { base: 50 }]
      : [{ base: ziel, mult: 2 }];
  },
  // Die Punktsumme sagt bei Bob's nichts ("60" kann T20 sein, also 0 Treffer).
  // In der Zeile steht deshalb, was hier zaehlt.
  bilanz: (darts) => ({
    name: t("aufnahme.treffer", "Treffer"),
    wert: darts.filter(bobsTrifft).length,
  }),
  onAufnahme: (wuerfe) => {
    if (isBobsGameOver || !bobsPlayer) return false;
    submitBobsScore(wuerfe.filter(bobsTrifft).length);
    return true;
  },
});

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  startBobsGame,
  cancelBobsGame,
  submitBobsScore,
  undoBobsTurn,
  bobsEingabe,
});
